// 导入axios实例
import httpRequest from '@/http/axios'

// //post示例
// export function postDemo() {
//     return httpRequest({
// 		url: '',
// 		method: 'post',
// 		data: param,
// 	})
// }
// //get示例
// export function getDemo(id) {
//     return httpRequest({
// 		url: `xxx?id=${id}`,
// 		method: 'get',
// 	})
// }
//lingyungeJS

let base_ling = "https://lyg.tsl3060.com/index.php/api";
export function getList() {
    return httpRequest({
		url: `${base_ling}/index/index`,
		method: 'get',
	})
}

//lingyungeJS结束